module.exports = __webpack_public_path__ + "img/sii-imagotipo-blanco.7c02d876.svg";